import { useMemo } from 'react';
import { DisplayQuantityToggle } from '../../../../components/quantity-toggle';
import type { EditOrderViewModel } from '../hooks/use-edit-order-view';
import { EditOrderTable } from './edit-order-table';
import { EditOrderToolbar } from './edit-order-toolbar';
import { OrderSummaryHeader } from './order-summary-header';

export function OrderView({ view }: { view: EditOrderViewModel }) {
  // The summary header reduces over every order item, and this component
  // re-renders on each keystroke in a quantity or search input. Memoizing the
  // element keeps that work tied to the data it actually reads, and gives the
  // table a stable element to bail out on — the pre-split index.tsx memoized
  // this same JSX on the same dependencies.
  const headerContent = useMemo(
    () => (
      <OrderSummaryHeader
        items={view.filteredOrderItems}
        columns={view.orderedVisibleColumns}
        columnSizing={view.columnSizing}
      />
    ),
    [view.filteredOrderItems, view.orderedVisibleColumns, view.columnSizing]
  );

  return (
    <>
      <EditOrderToolbar
        view={view}
        rightExtra={
          <DisplayQuantityToggle
            displayInCases={view.displayInCases}
            setDisplayInCases={view.setDisplayInCases}
          />
        }
      />
      <EditOrderTable view={view} headerContent={headerContent} />
    </>
  );
}
